<template>
  <div id="operationsDetail" class="operations-detail">
    <second-menu-link-content>
      <template v-slot:header>
        <span class="title" @click="toOperationLog">操作日志/</span>操作记录
      </template>
      <template v-slot:content>
        <div class="operations">
          <div class="time-search">
            <span class="desc">操作时间：</span>
            <el-date-picker
              class="date-picker"
              v-model="queryTimeRange"
              type="daterange"
              range-separator="至"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
            <el-button class="btn-blue" @click="onSearch">查询</el-button>
          </div>
          <div class="table">
            <el-table class="table-container" :data="operationRecordList">
              <el-table-column label="操作人" prop="operator" width="150"></el-table-column>
              <el-table-column label="部门名称" prop="deparment" width="150"></el-table-column>
              <el-table-column label="操作时间" prop="operationTime" width="200"></el-table-column>
              <el-table-column label="操作记录" prop="operationDesc"></el-table-column>
            </el-table>
          </div>
          <div class="pagination-tpl-container">
            <pagination-tpl
              class="pagination-tpl"
              :total="operationRecordTotal"
              @queryChange="handleQueryChange"
            ></pagination-tpl>
          </div>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import PaginationTpl from "base/PaginationTpl";
import { formaTimeToSecond } from "common/js/util.js";
import DBSiteLog from "models/db/site-log.js";
const dbSiteLog = new DBSiteLog();
export default {
  data() {
    return {
      currentPage: 1,
      queryTimeRange: null,
      // 操作记录列表
      operationRecordList: [],
      // 操作记录总条数
      operationRecordTotal: 0,
      // 无参数查询
      queryWithNoParam: true,
      // 上次查询条件
      options: null
    };
  },
  methods: {
    toOperationLog() {
      // 返回 操作日志 主页
      this.$router.push({
        path: "/admin/home/log/operation-log"
      });
    },
    onSearch() {
      // 根据时间查询记录，点击查询时要将currentPage重置为1
      this.currentPage = 1;
      // 将这次的查询参数记录下来
      this.options = this.queryTimeRange;
      this.queryWithNoParam = false;
      let startTime;
      let endTime;
      if (!this.queryTimeRange) {
        startTime = "";
        endTime = "";
      } else {
        startTime = this.queryTimeRange[0];
        endTime = this.queryTimeRange[1];
      }
      this._getOperationLogByTime(
        this.userId,
        this.currentPage,
        startTime,
        endTime
      );
    },
    handleQueryChange(query) {
      let userId = this.$route.params.userId;
      let currentPage = query.currentPage;
      if (this.queryWithNoParam) {
        this._getOperationRecordList(userId, currentPage);
      } else {
        let startTime = this.options[0] ? this.options[0] : "";
        let endTime = this.options[1] ? this.options[1] : "";
        this._getOperationLogByTime(
          this.userId,
          currentPage,
          startTime,
          endTime
        );
      }
    },
    // 无参数获取操作记录列表
    _getOperationRecordList(userId, currentPage) {
      dbSiteLog
        .getOperationRecordList(userId, currentPage)
        .then(res => {
          if (res.success) {
            let { totalNum, items } = res.result;
            this.operationRecordTotal = totalNum;
            // 重置
            this.operationRecordList = [];
            items.map(item => {
              this.operationRecordList.push({
                operator: item.username ? item.username : "----",
                deparment: item.name ? item.name : "----",
                operationTime: formaTimeToSecond(item.time),
                operationDesc: item.description ? item.description : "----"
              });
            });
          } else {
            console.log("查询失败", res.message);
          }
        })
        .catch(e => {
          console.log("查询异常");
        });
    },
    // 根据时间段查询操作记录列表
    _getOperationLogByTime(userId, currentPage, startTime, endTime) {
      dbSiteLog
        .getOperationLogByTime(userId, currentPage, startTime, endTime)
        .then(res => {
          if (res.success) {
            console.log("查询成功", res.result);
            let { totalNum, items, currentPage } = res.result;
            this.operationRecordTotal = totalNum;
            this.currentPage = currentPage;
            // 重置
            this.operationRecordList = [];
            items.map(item => {
              this.operationRecordList.push({
                operator: item.username ? item.username : "----",
                deparment: item.name ? item.name : "----",
                operationTime: formaTimeToSecond(item.time),
                operationDesc: item.description ? item.description : "----"
              });
            });
          } else {
            console.log("查询失败", res.message);
          }
        })
        .catch(e => {
          console.log("查询异常", e);
        });
    }
  },
  created() {
    this.userId = this.$route.query.userId;
    this._getOperationRecordList(this.userId, this.currentPage);
  },
  components: {
    SecondMenuLinkContent,
    PaginationTpl
  }
};
</script>

<style lang="scss" scoped>
.operations-detail {
  width: 100%;
  height: 100%;
  .title {
    color: rgba(61, 116, 242, 0.75);
    cursor: pointer;
    &:hover {
      color: rgba(61, 116, 242, 1);
    }
  }
  .operations {
    display: flex;
    flex-direction: column;
    .time-search {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 16px;
      .desc {
        font-size: 14px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(96, 98, 102, 1);
      }
      .date-picker {
        margin-right: 16px;
      }
      .btn-blue {
        width: 96px;
      }
    }
    .pagination-tpl-container {
      padding: 10px 24px 0px;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
    }
  }
}
</style>

<style lang="scss">
#operationsDetail {
  .el-table {
    .el-table__header {
      .has-gutter {
        tr {
          th {
            color: #606266;
            background: rgba(245, 247, 250, 1);
          }
        }
      }
    }
  }
}
</style>
